import clsx from "clsx";
import React from "react";

import { Tab } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/outline";

import ItemContent from "./item-content";
import features from "./list";

const DesktopList = () => (
  <div className="space-x-12 items-start hidden lg:flex">
    <Tab.Group>
      <Tab.List className="space-y-2 flex-shrink-0 sticky top-16 p-6">
        {features.map(feature => (
          <Tab
            key={feature.title}
            className={({ selected }) =>
              clsx(
                "flex justify-between items-center space-x-4 border-2 p-4 w-full whitespace-nowrap",
                selected
                  ? "text-gray-800 border-white bg-gradient-to-r from-white to-[#B2DAFF]"
                  : "text-white border-primary bg-navy"
              )
            }
          >
            {({ selected }) => (
              <>
                <span>{feature.title}</span>
                <ChevronRightIcon className={clsx("h-5 w-5", selected && "text-primary")} />
              </>
            )}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="xl:p-10">
        {features.map(feature => (
          <Tab.Panel key={feature.title}>
            <ItemContent {...feature} />
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  </div>
);

export default DesktopList;
